import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useGame } from '../context/GameContext';
import { Award } from 'lucide-react';

export default function AchievementToasts() {
  const { achievementToasts } = useGame();
  return (
    <div className="fixed top-24 right-6 z-50 flex flex-col gap-3 pointer-events-none">
      <AnimatePresence>
        {achievementToasts.map(t => (
          <motion.div
            key={t.id}
            initial={{ opacity: 0, x: 300, scale: 0.9 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 300, scale: 0.8 }}
            transition={{ type: 'spring', stiffness: 260, damping: 22 }}
            className="brutal-border-pink bg-[#0a0a0a] p-4 min-w-[280px] max-w-[360px] brutal-shadow-pink pointer-events-auto"
            data-testid={`achievement-toast-${t.achievement.id}`}
          >
            <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-[color:var(--pink)]">
              <Award size={14}/> ACHIEVEMENT UNLOCKED
            </div>
            <div className="mt-1 font-display font-black text-xl uppercase text-[color:var(--neon)]">{t.achievement.name}</div>
            <div className="text-xs text-[color:var(--text-dim)] mt-1">{t.achievement.desc}</div>
            <div className="text-xs text-[color:var(--pink)] mt-2 font-bold">+{t.achievement.tokens} SLOP TOKENS {t.achievement.title ? `· TITLE: ${t.achievement.title}` : ''}</div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
